import React from "react";

export default function NavigationLabel({ date, label, locale, view, _id, _className }: any) {
  return (
    <div id={_id} className={`${_className} ${_id}`}>
      {label}
    </div>
  );
}
